﻿import { FC } from 'react';
import { Container, Section, Card, Badge } from '../components/ui';
import { SEOHead } from '../components/seo';
import { siteConfig } from '../config/site';
import { PageProps } from './HomePage';

export const TermsPage: FC<PageProps> = () => {
  return (
    <>
      <SEOHead
        title="Terms of Service — Connect Source"
        description="Connect Source terms of service. Review single-user license terms, digital product usage, and professional advisory disclaimers."
      />

      <Section style={{ backgroundColor: '#ffffff', borderBottom: '1px solid var(--color-border-subtle)', padding: '4rem 0' }}>
        <Container size="md">
          <Badge variant="neutral" style={{ marginBottom: '1rem' }}>Legal & Terms</Badge>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--color-navy-dark)', lineHeight: 1.2 }}>
            Terms of Service
          </h1>
          <p style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', marginTop: '0.5rem' }}>
            Last Updated: October 2026 • Connect Source
          </p>

          <Card style={{ marginTop: '2.5rem', padding: '2.5rem', lineHeight: 1.75, color: 'var(--color-text-secondary)', fontSize: '0.95rem' }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-navy-dark)', marginBottom: '0.5rem' }}>
              1. Acceptance of Terms
            </h2>
            <p style={{ marginBottom: '1.5rem' }}>
              By accessing Connect Source, browsing our website, acquiring our digital toolkits, or engaging in professional career coaching or business consulting, you agree to be bound by these Terms of Service.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-navy-dark)', marginBottom: '0.5rem' }}>
              2. Single-User Digital License
            </h2>
            <p style={{ marginBottom: '1.5rem' }}>
              All digital products, including the ATS Resume Master Kit, LinkedIn Profile Optimization Toolkit, Interview Cracker Kit, AI Job Search Toolkit, and 30-Day Job Switch Blueprint, are licensed exclusively for individual, single-user personal use. You may not resell, republish, redistribute, sublicense, or share downloaded files across public networks or shared corporate drives without explicit written permission from Connect Source.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-navy-dark)', marginBottom: '0.5rem' }}>
              3. Professional Advisory Disclaimer
            </h2>
            <p style={{ marginBottom: '1.5rem' }}>
              Connect Source provides career coaching, ATS optimization frameworks, and operational HR advice. While our methodologies adhere to modern hiring standards and professional best practices, Connect Source does not promise or guarantee specific employment outcomes, job offers, or fixed salary increases. Hiring decisions are governed exclusively by third-party prospective employers.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-navy-dark)', marginBottom: '0.5rem' }}>
              4. Intellectual Property
            </h2>
            <p style={{ marginBottom: '1.5rem' }}>
              All methodologies, frameworks, proprietary text, graphics, and course outlines published on this platform remain the exclusive intellectual property of Connect Source and Nilesh Mishra. Unauthorized commercial reproduction is strictly prohibited.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-navy-dark)', marginBottom: '0.5rem' }}>
              5. Governing Law
            </h2>
            <p>
              These Terms of Service are governed by and construed in accordance with the laws of India. Any disputes arising hereunder shall be subject to the exclusive jurisdiction of the competent courts in India. For inquiries, contact <a href={`mailto:${siteConfig.contactEmail}`} style={{ color: 'var(--color-brand-primary)' }}>{siteConfig.contactEmail}</a>.
            </p>
          </Card>
        </Container>
      </Section>
    </>
  );
};


